module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4905-d1815921f90fc345472179de4e076b3f.jpg";